import { render, staticRenderFns } from "./hours.vue?vue&type=template&id=c8c840f4&"
import script from "./hours.vue?vue&type=script&lang=js&"
export * from "./hours.vue?vue&type=script&lang=js&"
import style0 from "./hours.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports